import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[headerFor],[mbsTableHeader]'
})
export class TableHeaderNameDirective {
  template = inject<TemplateRef<any>>(TemplateRef);

  public value: string;
  /**
   * @deprecated
   * @param {string} value
   */
  @Input('headerFor') set headerFor(value: string) {
    this.value = value;
  }
  @Input('mbsTableHeader') set mbsTableHeader(value: string) {
    this.value = value;
  }
}
